import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SeoPage } from './SeoPage.js';
import { getSeoPageFromPath } from './seo-pages.js';
import './seo-pages.css';

const root = document.querySelector('#root');
if (!root) throw new Error('Application root element was not found');

const page = getSeoPageFromPath(globalThis.location.pathname);
if (!page) {
  globalThis.location.replace('/');
} else {
  createRoot(root).render(
    <StrictMode>
      <SeoPage page={page} />
    </StrictMode>,
  );
}
